/** basic.deviceProfile */
export default {
    profile_modelName: "Название модели",
    profile_modelNamePla: "Введите название модели",
    profile_enttity: "Название организации",
    profile_entityPla: "Введите название организации",
    profile_tableModelName: "Название модели",
    profile_drawerTitle: "Детали модели устройства",
    profile_basiceLabel: "Основная информация",
    profile_dialogTitle: "Новая модель устройства",

    addForm_IDPla: "Введите ID",
    addForm_appkeyPla: "Введите aep_appkey",
    addForm_appsecretPla: "Введите aep_appsecret",
    addForm_product_idPla: "Введите product_id",
    addForm_command_idPla: "Введите command_id",
    addForm_masterkey: "Введите masterkey",
    addForm_protocol_type: "Введите protocol_type",
    addForm_protocol_typeRule: "protocol_type не может быть пустым",

    addForm_expire_time: "Время кэширования команды",
    addForm_expire_timePla: "Введите время кэширования команды",
    addForm_onenet_apikeyPla: "Введите onenet_apikey",
    addForm_BC260Y: "Устройство BC260Y",
    addForm_BC260YPla: "Введите устройство BC260Y",
    addForm_Platform: "Платформа оператора",
    addForm_PlatformPla: "Введите платформу оператора",
    addForm_creator: "Создатель",
    addForm_creatorPla: "Введите имя создателя",
    addForm_onenerPla: "Введите мобильный onener",

    rules_modelNameNoSpace: "Название модели не может быть пустым",
    rules_modelNameLength: "Длина не должна превышать 20",
    rules_maxLength: "Длина не должна превышать 50",
    rules_entityNoSpace: "Организация не может быть пустой",
    rules_platform: "Платформа оператора не может быть пустой",

    message_entity: "Организация не может быть пустой!",
    message_addDeviceSucc: "Модель устройства добавлена!",
    message_addDeviceLose: "Не удалось добавить модель!",
}

